import Table from './blockComponents/Table';
export var getBlockRendererFn = function getBlockRendererFn(editorContainerRef, readOnly) {
  return function (block) {
    var type = block.getType();
    switch (type) {
      case 'table':
        return {
          component: Table,
          editable: !readOnly,
          props: {
            editorContainerRef: editorContainerRef
          }
        };
      default:
        return null;
    }
  };
};